import { BaseTabRenderer } from "./BaseTabRenderer";

export class InvoicesRenderer extends BaseTabRenderer {
    getListId() {
        return "accordionInvoices";
    }

    getListDataName() {
        return "invoicesList";
    }

    getPaginationTemplateId() {
        return "invoices-pagination-template";
    }

    getPaginationDataName() {
        return "invoicesPagination";
    }

    getPageParamName() {
        return "invoices_page";
    }

    getPaginationLinkTemplateId() {
        return "invoices-pagination-link-template";
    }

    createItemNode(item) {
        const template = this.find("#invoice-item-template");
        if (!(template instanceof HTMLTemplateElement)) {
            return document.createElement("div");
        }

        const node = template.content.firstElementChild.cloneNode(true);
        const itemId = String(item.id);
        const collapseId = `invoice-collapse-${itemId}`;
        const headingId = `invoice-heading-${itemId}`;
        const icon = item.is_failed
            ? "bx bx-x-circle text-danger"
            : (item.is_waiting ? "bx bx-time-five text-warning" : "bx bx-check-circle text-success");

        this.setText(node, "createdAtShort", item.created_at_short);
        this.setText(node, "amountFormatted", item.amount_formatted);
        this.setText(node, "statusLabelPrefix", item.labels?.status);
        this.setText(node, "statusLabel", item.status_label);
        this.setText(node, "dateLabelPrefix", item.labels?.date);
        this.setText(node, "createdAtHuman", item.created_at_human);
        this.setText(node, "id", item.id);
        this.setText(node, "amountLabelPrefix", item.labels?.amount);
        this.setText(node, "amountFormattedDetails", item.amount_formatted);
        this.setText(node, "purchasedLabelPrefix", item.labels?.purchased);
        this.setText(node, "purchasedLabel", item.purchased_label);
        this.setText(node, "filesLabel", item.labels?.files);
        this.setText(node, "supportLabel", item.labels?.support);
        this.setText(node, "receiptLabel", item.labels?.receipt);

        const statusIcon = this.getField(node, "statusIcon");
        statusIcon.className = icon;

        const header = node.querySelector(".accordion-header");
        header.id = headingId;

        const button = node.querySelector(".accordion-button");
        button.setAttribute("data-bs-target", `#${collapseId}`);
        button.setAttribute("aria-controls", collapseId);

        const collapse = this.getField(node, "collapseRoot");
        collapse.id = collapseId;
        collapse.setAttribute("aria-labelledby", headingId);
        collapse.setAttribute("data-bs-parent", "#accordionInvoices");

        const supportLink = this.getField(node, "supportLink");
        supportLink.href = item.support_url || "#";

        const filesWrap = this.getField(node, "filesLinkWrap");
        if (item.has_transcription_result && item.files_url) {
            filesWrap.classList.remove("d-none");
            this.getField(node, "filesLink").href = item.files_url;
        }

        const receiptWrap = this.getField(node, "receiptWrap");
        if (item.receipt_url) {
            receiptWrap.classList.remove("d-none");
            this.getField(node, "receiptLink").href = item.receipt_url;
        }

        return node;
    }

}

export default InvoicesRenderer;
